import { Component, ContentChild, ElementRef, EventEmitter, Input, OnChanges, OnDestroy, OnInit, Output, TemplateRef, ViewEncapsulation } from '@angular/core';
import { UntypedFormArray, FormGroup } from '@angular/forms';
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';
import { of, Subscription } from 'rxjs';
import { ToastService } from 'src/app/core';
import { CWProfile, ExitCandidate, ExitRequest } from 'src/app/core/api.gen';
import { AuthService } from 'src/app/core/auth.service';
import { CommonService } from 'src/app/core/common.service';
import { StepTypeExit } from 'src/app/exit/services/additional-info-step.service';

@Component({
  selector: 'eos-info-template',
  templateUrl: './info-template.component.html',
  styleUrls: ['./info-template.component.scss'],
})
export class InfoTemplateComponent implements OnInit, OnChanges, OnDestroy {

  @Input() steps: any[] = [];
  @Input() formArray: UntypedFormArray;
  @Input() model: any;
  @Input() exitType: string;
  @Output() saveEvent: EventEmitter<any> = new EventEmitter<any>();
  @Output() submitEvent: EventEmitter<any> = new EventEmitter<any>();

  @Input() showSubmit: boolean = true;
  @Input() showSave: boolean = true;
  @Input() module: string;

  formInitSub: Subscription;
  // @ContentChild('fileUpload', { static: false }) fileUpload: TemplateRef<ElementRef>;

  openStates: boolean[] = [];

  @Input() inModal: boolean = false;
  activeIds = [];

  constructor(
    public modal: NgbActiveModal,
    private auth: AuthService,
    private toast: ToastService,
    private common: CommonService) { }

  ngOnInit() {
    this.formInitSub = of(this.initializeForm()).subscribe(resp => {
      setTimeout(() => {
        this.activeIds = [];
        this.disableIfOnlyView();
        this.openStates = this.steps.map(() => false); 
      }, 100);
    });
  }

  ngOnChanges() {
    this.disableIfOnlyView();
  }

  initializeForm() {
    for (let i = 0; i < this.steps.length; i++) {
      this.activeIds.push('panel-' + i);
    }
  }

  isOpen(index: number): boolean {
    return this.openStates[index];
  }

  toggle(index: number) {
    this.openStates[index] = !this.openStates[index];
  }

  save(step: any, index: number) {
    if (!this.formArray.at(index).dirty) {
      this.toast.warning("No changes to save");
      return;
    }
    const request = new ExitCandidate()
    request.roleName = step.role;
    this.saveEvent.emit(request);
  }
  
  submit(step: any, index: number) {
    if (this.checkFormStatus(index)) {
      return;
    }
    if(this.module=='CW'){
      const request = new CWProfile()
      
      this.submitEvent.emit(this.model);
    }
    else{
      const request = new ExitCandidate()
      request.roleName = step.role;
      this.submitEvent.emit(request);
      this.checkStatus(step.role);
    }
  }

  setModel(model:ExitRequest) {
    this.model.status = model.status;
    //For new stakholders and new fields coming 
    //in please map it to the model in the folling functions 
    this.mapStakeHolderResponses(model);
    this.mapStakeHolders(model);
    this.disableIfOnlyView();
  }

  mapStakeHolderResponses(model: ExitRequest) {
    this.model.itAssetDetails = model.itAssetDetails;
    this.model.pqDetails = model.pqDetails;
    this.model.leadRating = model.leadRating;
    this.model.lmsBalance = model.lmsBalance;
    this.model.visaApproverComment = model.visaApproverComment;
    this.model.hrccComment = model.hrccComment;
    this.model.financeTeamComment = model.financeTeamComment;
    this.model.arcAndCanvasComment = model.arcAndCanvasComment;
    this.model.amexCardBalance = model.amexCardBalance;
    this.model.guidanceMailComment = model.guidanceMailComment;
  }

  mapStakeHolders(model:ExitRequest){
    this.model.itTeam = model.itTeam;
    this.model.expense = model.expense;
    this.model.lms = model.lms;
    this.model.amex = model.amex;
    this.model.arcAndCanvas = model.arcAndCanvas;
    this.model.leadsTeam = model.leadsTeam;
    this.model.hrcc = model.hrcc;
    this.model.financeTeam = model.financeTeam;
    this.model.visaApprover = model.visaApprover;
    this.model.guidanceMail = model.guidanceMail;
  }
  // onSave(step: any, index: number, submit: boolean) {
  //   const request = new ExitCandidate()
  //   request.roleName = step.role;
  //   this.saveEvent.emit(request);
  // }
  checkFormStatus(index: number) {
    const fg = this.formArray.at(index)
    return fg.invalid ? true : false;
  }

  get isMailSameOrExitTeam(){

    return (this.model.exitEmployee && (this.model.exitEmployee.email.toUpperCase() == this.auth.ActiveUser.email.toUpperCase()))
           || this.isExitTeam;
  }

  get exitEmployee(){
    return this.model.exitEmployee;
  }

  checkStatus(d: any) {
    //console.log(this.model.it);
  }

  disableIfOnlyView() {
    if ((this.model.status && this.model.status.id && this.profileCompleted) ) {
      this.formArray.disable();
    }
    this.steps.map((step, index) => {
      if (this.noAccess(step.role)
        || this.ifNoExitAndSubmitted(step) ) {
        this.formArray.at(index).disable();
        step.enableSaveAndSubmit = false;
      }
   })
  }

  get profileCompleted() {
    if (this.model.status && this.model.status.id) {
      return [10857].includes(this.model.status.id);
    }

    return false;
  }

  get statusIsForbidden() {
    if (this.model.status && this.model.status.id) {
      return [10852].includes(this.model.status.id);
    }

    return false;
  }

  get enableSubmit() {
    if(this.module=='CW'){
      return this.isCWTeam && !this.profileCompleted;
    }
    return this.isExitTeam && !this.profileCompleted;
  }

  noAccess(team) {
    return (this.auth.isAuthorised(`${team}-View`) && !this.auth.isAuthorised(`${team}-Edit`));
  }

  ifNoExitAndSubmitted(step) {
    return !this.isExitTeam
      && this.model[step.teamInfoprop]
      && this.model[step.teamInfoprop].submittedDate
  }

  get isExitTeam() {
    return this.common.isExitTeam
  }

  get isCWTeam() {
    return this.common.isContingentWorkerTeam;
  }

  close() {
    this.modal.close(this.model);
  }

  GetDocuments($event) { }
  setValidDocuments($event) { }

  ngOnDestroy() {
    this.formInitSub.unsubscribe();
  }


}
